

const Config = require('config').default
const VueAnalytics = require('vue-analytics').default
const Vue = require('vue')

const isProd = ARCHII_ENV === 'production'

function setMetaInfo(info) {
    document.title = info.title
    document.head.querySelector('meta[name=description]').content = info.metaTag
}

// Set router hooks that change the page metadata (title and meta[name=description] content)
// whenever you navigate.
function wrapMetaHooks (router, metaInfo) {

    router.beforeEach((to, from, next) => {

        const info = metaInfo[to.path] || metaInfo['/']

        if (info) {
            setMetaInfo(info)
        }

        next()
      })
}

function setupAnalytics (router) {

    Vue.use(VueAnalytics, {
        router,
        id: Config.googleAnalyticsId,
        checkDuplicatedScript: true,
        debug: {
            sendHitTask: isProd,
            enabled: Config.debugAnalytics
        }
      })
}

module.exports = { wrapMetaHooks, setMetaInfo, setupAnalytics }



// WEBPACK FOOTER //
// ./apps/utils/index.js